/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  createApi,
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";

import type { RootState } from "../app/store";
import { resetAuth } from "../reducers/authSlice";
import { API_URL } from "../constants/urls";
import { getFromStorage } from "../helpers/storage";
import { STORAGE_KEYS } from "../helpers";
import { encryptAES } from "./crypto";
// import { generateEncryptedKeyBody } from "./crypto";

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: (headers, { getState, extra }) => {
    const { token } = (getState() as RootState).auth;
    const { tempToken } = (getState() as RootState).auth;
    const tokenFromStorage = getFromStorage(STORAGE_KEYS.token);
    let tokenKey;
    if (token) {
      tokenKey = token;
    } else if (tempToken) {
      tokenKey = tempToken;
    } else {
      tokenKey = tokenFromStorage;
    }

    // const encryptData = generateSEKAndHash(token || tempToken || null);

    // if (encryptData) {
    //   headers.set("hash", encryptData?.hash);
    //   headers.set("sek", encryptData?.sek);
    // }

    if (token || tempToken || tokenFromStorage) {
      headers.set("authorization", `Bearer ${tokenKey}`);
    }

    return headers;
  },
});

const baseQueryWithAuth: BaseQueryFn<
  string | FetchArgs | any,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  if (typeof args !== "string" && args?.body instanceof FormData) {
    return await baseQuery(args, api, extraOptions);
  }

  let modifiedArgs = args;

  // 🧠 Encrypt normal JSON bodies
  if (typeof args !== "string" && args?.body) {
    const headers = new Headers(args.headers || {});

    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");

    try {
      const jsonString = JSON.stringify(args.body);
      if (jsonString) {
        const encryptedBody = await encryptAES(jsonString);
        modifiedArgs = {
          ...args,
          body: JSON.stringify({ payload: encryptedBody }),
          headers,
        };
      } else {
        console.warn("[API ENCRYPTION] Skipping empty JSON body");
      }
    } catch (e) {
      console.error("Request encryption failed:", e);
    }
  }

  const result = await baseQuery(modifiedArgs, api, extraOptions);
  if (result.error?.status === 400) {
    const errors = Object.values(result?.error?.data || {});
    console.error(errors);

    if (errors?.length > 1 && errors[1] === 400) {
      return result;
    }
    if (errors?.length) {
      const error = errors[0] as any;
      if (error?.length) {
        console.error(error[0]);
      }
    }
  }
  if (result?.error?.status === 401) {
    api.dispatch(resetAuth());
    if (window) {
      window.location.replace("/");
    }
  }
  if (
    result.error &&
    result.error.status === 401 &&
    (api.getState() as RootState).auth.user
  ) {
    api.dispatch(resetAuth());
  }

  return result;
};

const emptySplitApi = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: ["UNAUTHORIZED", "UNKNOWN_ERROR", "EMAIL", "BRAND"],
  endpoints: () => ({}),
});

export default emptySplitApi;
